module.exports = __webpack_public_path__ + "static/media/View_Study_Reference_Mar31-2022.609d92a6.pdf";